import { ComplianceAppBaseDataProvider } from './ComplianceAppBaseDataProvider';
import { ComplianceAppWebComponentSchema } from '../types';
import {
  GenericComplianceDataRequest,
  GetDashboardDataResponse,
  GetControlIdentitiesResponse,
  GetControlResourcesResponse,
  GetControlAssetsRequest,
  GetRisksRequest,
  GetRisksResponse,
} from '@nirvana/shared/dtos/types/compliance-reports/gz-console';

export class ComplianceAppNirvanaDataProvider extends ComplianceAppBaseDataProvider {
  async getDataForView(): Promise<ComplianceAppWebComponentSchema> {
    return {} as unknown as ComplianceAppWebComponentSchema;
  }

  async getMisconfigurations(request: GetRisksRequest): Promise<GetRisksResponse> {
    const response = await this.dependencies.api.clients.ComplianceReports.getMisconfigurations(request).toPromise();
    return response;
  }

  async getUserBehaviorRisks(request: GetRisksRequest): Promise<GetRisksResponse> {
    const response = await this.dependencies.api.clients.ComplianceReports.getUserBehaviorRisks(request).toPromise();
    return response;
  }

  async getControlResources(request: GetControlAssetsRequest): Promise<GetControlResourcesResponse> {
    const response = await this.dependencies.api.clients.ComplianceReports.getControlResources(request).toPromise();
    return response;
  }

  async getControlIdentities(request: GetControlAssetsRequest): Promise<GetControlIdentitiesResponse> {
    const response = await this.dependencies.api.clients.ComplianceReports.getControlIdentities(request).toPromise();
    return response;
  }

  async generatePdf(request: GenericComplianceDataRequest): Promise<any> {
    return this.dependencies.api.clients.ComplianceReports.generatePdf(request).toPromise();
  }

  async generateXlsx(request: GenericComplianceDataRequest): Promise<any> {
    return this.dependencies.api.clients.ComplianceReports.generateXlsx(request).toPromise();
  }

  async getDashboardData(request: GenericComplianceDataRequest): Promise<GetDashboardDataResponse> {
    return this.dependencies.api.clients.ComplianceReports.getDashboardData(request).toPromise();
  }
}
